import React, { useState, useEffect } from "react";
import { roundValue, toDecimal } from "../../util/decimal-utils";
import _ from "lodash";
import {
  setVendorPayment,
  getProjectList,
  getPoVendors,
  getPOList,
  getPurchaseOrder as getProjectPurchaseOrder,
} from "../../actions/project-management.action";
import "./scss/style.scss";
import { warningSnackBar } from "../../actions/common.action";
import Modal from "../../components/modal/modal";
import FileUploader from "../../components/file-uploader";
import idx from "idx";
import DatePickerInput from "../../components/inputs/date-picker";
import Form from "react-bootstrap/Form";
import Table from "react-bootstrap/Table";
import SelectInput from "../../components/inputs/select";
import CustomInput, { LockInput } from "../../components/inputs/new-input";
import TextAreaInput from "../../components/inputs/textarea-input";
import { toUSD } from "../../util/currency-formatter";
import { getGlobalSetting } from "../../actions/global-setting.action";
import EditIcon from "@mui/icons-material/Edit";
import LockIcon from "@mui/icons-material/Lock";
import LockOpenIcon from "@mui/icons-material/LockOpen";
import AddItemDialog from "../projects/add-item-dialog";
import { useSelector, useDispatch } from "react-redux";
import { addDays, formatISO } from "date-fns";
import { ValidateField, ValidatorTypes } from "../../util/validators";
import { sortVendorList } from "src/util/common";
import { VENDOR_TYPE, VENDOR_TYPE_LABEL } from "../../constants/vendor.contant";

export default function PayInvoice(props) {
  const {
    invoiceNumber,
    invoiceClaim,
    notes,
    approvedPayment,
    invoiceUrl,
    poNo,
    poNumber,
    poId,
    projectId,
    vendorId,
    isSubContractor,
    initialVendorType,
    handleClose,
    payInvoiceType,
    getWOList,
    handleDownloadDialog,
    invoiceId,
    workType,
  } = props;

  const [fields, setFields] = useState({
    invoiceNumber: {
      name: "invoiceNumber",
      label: "Invoice Number",
      type: "text",
      touched: false,
      error: false,
      valid: true,
      value: invoiceNumber || "",
      dataCy: "invoice-number-input",
      validation: [ValidatorTypes.REQUIRED],
    },
    invoiceDate: {
      name: "invoiceDate",
      label: "Invoice Date",
      type: "datepicker",
      touched: false,
      error: false,
      valid: true,
      value: "",
      dataCy: "invoice-date-input",
      validation: [ValidatorTypes.REQUIRED],
    },
    dueDate: {
      name: "dueDate",
      label: "Due Date",
      type: "datepicker",
      touched: false,
      error: false,
      valid: true,
      value: "",
      dataCy: "due-date-input",
      validation: [ValidatorTypes.OPTIONAL],
    },
    invoiceClaim: {
      name: "invoiceClaim",
      label: "Invoice Total",
      type: "number",
      touched: false,
      error: false,
      valid: true,
      disable: !isSubContractor,
      value: invoiceClaim || 0,
      dataCy: "invoice-claim-input",
      validation: [ValidatorTypes.OPTIONAL],
    },
    approvedPayment: {
      name: "approvedPayment",
      label: "Approved For Payment",
      disable: !isSubContractor,
      type: "number",
      touched: false,
      error: false,
      valid: true,
      value: approvedPayment || invoiceClaim || 0,
      dataCy: "approved-payment-input",
      validation: [ValidatorTypes.REQUIRED],
    },
    lessRetention: {
      name: "lessRetention",
      label: "Retention",
      type: "number",
      touched: false,
      error: false,
      valid: true,
      value: 0,
      disable: false,
      dataCy: "less-retention-input",
      validation: [ValidatorTypes.OPTIONAL],
    },
    progressClaimNumber: {
      name: "progressClaimNumber",
      label: "Progress Claim Number",
      type: "text",
      touched: false,
      error: false,
      valid: true,
      value: 1,
      dataCy: "progress-claim-number-input",
      validation: [ValidatorTypes.REQUIRED, ValidatorTypes.PROGRESS_CLAIM_NUMBER],
    },
    notes: {
      name: "notes",
      label: "Approval Notes",
      type: "textarea",
      touched: false,
      error: false,
      valid: true,
      value: notes || "",
      dataCy: "notes-input",
      validation: [ValidatorTypes.OPTIONAL, ValidatorTypes.TEXTAREA],
    },
    attachment: {
      name: "invoiceURL",
      label: "Invoice Document",
      type: "file",
      touched: false,
      error: false,
      valid: true,
      value: invoiceUrl || "",
      dataCy: "invoice-attachment-input",
      validation: [ValidatorTypes.OPTIONAL],
    },
  });
  const [state, setState] = useState({
    projectId: props.projectId || null,
    projectsList: [],
    vendorId: props.vendorId || null,
    vendorsList: [],
    poId: poId,
    poNo: poNo || poNumber,
    fId: null,
    vendorName: null,
    projectName: null,
    poList: [],
    items: [],
    isSubContractor: isSubContractor || false,
    selectedVendorType:
      (initialVendorType === VENDOR_TYPE.SUB_CONTRACTOR || initialVendorType === VENDOR_TYPE.CONTRACTOR)
        ? VENDOR_TYPE_LABEL.CONTRACTOR
        : (initialVendorType === VENDOR_TYPE.SUPPLIER || initialVendorType === 'Supplier')
          ? VENDOR_TYPE_LABEL.SUPPLIER
          : (isSubContractor ? VENDOR_TYPE_LABEL.CONTRACTOR : VENDOR_TYPE_LABEL.SUPPLIER),
    paymentTerms: 0,
    isDEpo: false, // Add isDEpo state
    invoiceTotal: {
      subTotal: 0,
      approvedSubTotal: 0,
      gst: 0,
      taxAmount: 0,
      approvedTaxAmount: 0,
      total: 0,
      approvedTotal: 0,
    },
  });
  const [isSelectAll, setIsSelectAll] = useState(false);
  const [isInvoiceAll, setIsInvoiceAll] = useState(false);
  const [formSubmitted, setFormSubmitted] = useState(false);
  const dispatch = useDispatch();
  const permissions =
    useSelector((state) => state.user.userData.permissions) || {};
  const wCatalogPermission =
    idx(permissions, (_) => _.catalog) === 2 ? true : false;
  const [showAddItem, setShowAddItem] = useState(false);
  const [material, setMaterial] = useState({});
  const [lockUnitCosts, setLockUnitCosts] = useState(
    Array(state.items.length).fill(true)
  );

  useEffect(() => {
    setIsSelectAll(false);
    setIsInvoiceAll(false);

    const initialize = async () => {
      getGST();
      await getProject();

      const isContractor = props.isSubContractor || initialVendorType === VENDOR_TYPE.SUB_CONTRACTOR || initialVendorType === VENDOR_TYPE.CONTRACTOR || initialVendorType === "sub-contractor";
      const apiVendorType = isContractor ? 'sub-contractor' : 'Supplier';

      // Fetch vendors for the project
      let vendors = [];
      if (props.projectId) {
        const vendorsList = await dispatch(getPoVendors(props.projectId, apiVendorType)).catch(() => []);
        const sortedVendors = sortVendorList(vendorsList);
        sortedVendors.forEach((vendor) => {
          const vId = idx(vendor, (_) => _.vendor.id);
          if (vId && !vendors.find(({ value }) => value == vId)) {
            vendors.push({
              key: idx(vendor, (_) => _.vendor.business_name) || "",
              value: vId.toString(),
            });
          }
        });
      }

      // Ensure the pre-selected vendor is ALWAYS in the list
      if (props.vendorId && !vendors.find(({ value }) => value == props.vendorId)) {
        vendors.push({
          key: props.vendorName || "Selected Vendor",
          value: props.vendorId.toString(),
        });
      }

      // Fetch POs if vendorId is provided
      let pos = [];
      if (props.vendorId) {
        const { list: poList } = await dispatch(
          getPOList({
            vendorId: props.vendorId,
            projectId: props.projectId,
            vendorType: apiVendorType,
            vendorOrdersPage: true
          })
        ).catch(() => ({ list: [] }));

        (poList || []).forEach((po) => {
          const vType = idx(po, (_) => _.vendor?.type);
          const vTypeLower = (vType || "").toLowerCase();
          const isSupplierType = vTypeLower === "supplier" || vTypeLower === "2";
          const isContractorType = vTypeLower === "sub-contractor" || vTypeLower === "contractor" || vTypeLower === "1";

          let isValid = false;
          // CASE-INSENSITIVE and multiple field matching
          const pPoId = (props.poId || "").toString().toLowerCase();
          const uId = (po.u_id || "").toString().toLowerCase();
          const fId = (po.f_id || "").toString().toLowerCase();
          const id = (po.id || "").toString().toLowerCase();

          if (uId === pPoId || fId === pPoId || id === pPoId) {
            isValid = true;
          } else {
            const currentUISelection = isContractor ? VENDOR_TYPE_LABEL.CONTRACTOR : VENDOR_TYPE_LABEL.SUPPLIER;
            if (isSupplierType) {
              isValid = po.invoicestatus !== "Fully Invoiced" && currentUISelection === VENDOR_TYPE_LABEL.SUPPLIER;
            } else if (isContractorType) {
              isValid = po.status !== "Completed" && currentUISelection === VENDOR_TYPE_LABEL.CONTRACTOR;
            }
          }

          if (isValid) {
            pos.push({
              key: `${po.f_id || po.id}`,
              value: po.u_id.toString(),
              type: vType,
            });
          }
        });

        // Ensure the pre-selected PO is ALWAYS in the list
        if (props.poId && !pos.find(({ value }) => value.toString().toLowerCase() === props.poId.toString().toLowerCase())) {
          pos.push({
            key: props.poNo || props.poNumber || props.poId.toString(),
            value: props.poId.toString(),
            type: apiVendorType
          });
        }
      }

      setState((prevState) => ({
        ...prevState,
        isSubContractor: isContractor,
        selectedVendorType: isContractor ? VENDOR_TYPE_LABEL.CONTRACTOR : VENDOR_TYPE_LABEL.SUPPLIER,
        projectId: props.projectId ? props.projectId.toString() : prevState.projectId,
        vendorsList: vendors,
        vendorId: props.vendorId ? props.vendorId.toString() : prevState.vendorId,
        poList: pos,
        poId: props.poId ? props.poId.toString() : prevState.poId,
      }));

      if (props.poId) {
        getPurchaseOrder(props.poId);
      }
    };
    initialize();
  }, [state.selectedVendorType]);

  // Add effect to update dueDate whenever invoiceDate changes and paymentTerms exists
  useEffect(() => {
    if (
      fields.invoiceDate.value &&
      !fields.dueDate.value &&
      state.paymentTerms
    ) {
      setFields((prev) => ({
        ...prev,
        dueDate: {
          ...prev.dueDate,
          value: formatISO(
            addDays(
              new Date(fields.invoiceDate.value),
              Number(state.paymentTerms) - 1
            )
          ),
        },
      }));
    }
  }, [fields.invoiceDate.value, state.paymentTerms]);

  const editItemHandler = (res) => {
    const items = _.cloneDeep(state.items);
    const index = items.findIndex(
      (_) => _.id === res.id && _.taskId === res.taskId
    );
    if (index !== -1) {
      items[index] = { ...items[index], ...res };
      setState((prev) => ({
        ...prev,
        items,
      }));
      itemChangeHandler(res.cost, index, "unitCost");
    }
    setShowAddItem(!showAddItem);
  };
  const handleEditClick = (index) => {
    const item = state.items[index];
    const _material = {
      category: item.category,
      categoryId: item.categoryId,
      unitCost: item.cost,
      itemName: item.item,
      itemId: item.id,
      manufacturer: item.manufacturer,
      partNo: item.partNo,
      taskId: item.taskId,
      taskType: item.taskType,
      unit: item.unit,
    };
    setMaterial(_material);
    setShowAddItem(true);
  };
  const handleUnitCostLock = (index) => {
    setLockUnitCosts((prev) => {
      const newLockUnitCosts = [...prev];
      newLockUnitCosts[index] = !newLockUnitCosts[index];
      return newLockUnitCosts;
    });
  };

  useEffect(() => {
    setIsSelectAll(isInvoiceAll);
    if (isInvoiceAll) handleSelectAllChange(isInvoiceAll);
  }, [isInvoiceAll]);

  const getGST = async () => {
    const {
      data: { finance_gst },
    } = await dispatch(getGlobalSetting("LETTERHEAD")).catch((e) => {
      throw e;
    });
    setState((prev) => ({
      ...prev,
      invoiceTotal: {
        ...prev.invoiceTotal,
        gst: parseFloat(finance_gst || 0).toFixed(2),
      },
    }));
  };

  const inputChangeHandler = (e, fieldName = "") => {
    let name;
    let value;
    let type;
    if (e.target.files) {
      name = e.target.name;
      value = e.target.files[0];
    } else if (_.isObject(e)) {
      name = e.target.name;
      value = e.target.value;
      type = e.target.type;
    }
    if (type === "number") {
      if (name === "lessRetention" && state.isSubContractor) {
        value = isNaN(value) ? 0 : parseFloat(value);
      } else {
        value = isNaN(value) || parseFloat(value) < 0 ? 0 : parseFloat(value);
      }
    }
    const _fields = _.cloneDeep(fields);
    const { error, valid } = ValidateField({
      value: value,
      validation: _fields[name].validation,
    });

    
    setFields((prev) => ({
      ...prev,
      [name]: {
        ...prev[name],
        value: value,
        touched: true,
        // Only show error if form has been submitted, otherwise keep it false
        error: error,
        valid: valid,
      },
      ...(state.isSubContractor &&
        (fieldName === "invoiceClaim" || fieldName === "approvedPayment" || fieldName === "lessRetention")
        ? {
          invoiceClaim: {
            ...prev.invoiceClaim,
            value: fieldName === "invoiceClaim" ? value : prev.invoiceClaim.value,
          },
          approvedPayment: {
            ...prev.approvedPayment,
            value: fieldName === "lessRetention"
              ? (state.isSubContractor
                ? (state.invoiceTotal.approvedTotal || 0)
                : toDecimal(state.invoiceTotal.approvedTotal || 0).minus(toDecimal(value || 0)).toNumber())
              : fieldName === "approvedPayment" ? value : prev.approvedPayment.value,
          },
          lessRetention: {
            ...prev.lessRetention,
            value: fieldName === "lessRetention" ? value : prev.lessRetention.value,
          },
        }
        : {}),
      ...(fieldName === "invoiceClaim" && !state.isSubContractor
        ? { approvedPayment: { ...prev.approvedPayment, value: value } }
        : {}),
      ...(fieldName === "invoiceDate" && state.paymentTerms
        ? {
          dueDate: {
            ...prev.dueDate,
            value: formatISO(
              addDays(new Date(value), Number(state.paymentTerms) - 1)
            ),
          },
        }
        : {}),
    }));

    if (name === "lessRetention") {
      itemChangeHandler(value, null, "lessRetention");
    }
  };

  const submitForm = async (_generateInvoice = false) => {
    const { poId, items, isSubContractor } = state;
    let _fields = _.cloneDeep(fields);
    let isFormValid = true;

    // Set formSubmitted to true so validation errors will show up
    setFormSubmitted(true);

    for (let key in _fields) {
      if (_fields[key]) {
        const { value, validation } = _fields[key];
        const { error, valid } = ValidateField({ value, validation });
        _fields[key].touched = true;
        _fields[key].valid = valid;
        _fields[key].error = error;
        isFormValid = isFormValid && valid;
      }
    }

    // if (_fields.attachment.value === "") {
    //   dispatch(warningSnackBar("Please upload invoice test 3"));
    //   return;
    // }

    if (!isFormValid) {
      setFields(_fields);
    } else {
      const formData = new FormData();
      Object.keys(fields).forEach((key) => {
        if (fields[key]) {
          if (key === "lessRetention") {
            formData.append("retention", fields[key].value);
          } else {
            formData.append(key, fields[key].value);
          }
        }
      });
      const { subTotal, gst, taxAmount, total } = state.invoiceTotal;
      formData.append("subTotal", subTotal);
      formData.append("gstPercentage", gst);
      formData.append("taxAmount", taxAmount);
      formData.append("total", total);

      const selectedItems = items.filter((item) => {
        if (state.isSubContractor) {
          return toDecimal(item.claimAmount || 0).greaterThan(0);
        }
        return item.selected === true;
      });

      if (isSubContractor) {
        for (const item of selectedItems) {
          if (toDecimal(item.approvedAmount || 0).greaterThan(toDecimal(item.claimAmount || 0))) {
            dispatch(
              warningSnackBar("Approved amount cannot be greater than Invoice Claim amount")
            );
            return;
          }
          const remaining = toDecimal(item.total || 0).minus(toDecimal(item.previousInv || 0));
          if (toDecimal(item.claimAmount || 0).greaterThan(remaining)) {
            dispatch(warningSnackBar(`Invoice claim for "${item.description || item.name || 'an item'}" exceeds the remaining uninvoiced amount of ${toUSD(remaining.toNumber())}`));
            return;
          }
          if (toDecimal(item.approvedAmount || 0).greaterThan(remaining)) {
            dispatch(warningSnackBar(`Approved amount for "${item.description || item.name || 'an item'}" exceeds the remaining uninvoiced amount of ${toUSD(remaining.toNumber())}`));
            return;
          }
        }
      } else {
        for (const item of selectedItems) {
          const remaining = toDecimal(item.total || 0).minus(toDecimal(item.previousInv || 0));
          if (toDecimal(item.amountPaid || 0).greaterThan(remaining)) {
            dispatch(warningSnackBar(`Claim amount for "${item.item || item.name || 'an item'}" exceeds the remaining uninvoiced amount of ${toUSD(remaining.toNumber())}`));
            return;
          }
        }
      }

      for (const fieldValue in _fields) {
        const field = _fields[fieldValue];
        if (!field.valid) {
          if (
            field.name === "approvedPayment" ||
            field.name === "invoiceClaim"
          ) {
            if (selectedItems.length === 0) {
              dispatch(warningSnackBar("Please select at least one Task"));
              return;
            }
          }
          // else if (field.name === "invoiceURL") {
          //   dispatch(warningSnackBar("Please upload invoice test 4"));
          //   return;
          // }
          else {
            dispatch(warningSnackBar(`Field "${field.label}" is invalid.`));
            return;
          }
        }
      }

      for (var i = 0; i < selectedItems.length; i++) {
        delete selectedItems[i].selected;
        selectedItems[i].costPerItem = selectedItems[i].cost;
        // For suppliers, set name from item field; for subcontractors, preserve existing name (description)
        if (!state.isSubContractor) {
          selectedItems[i].name = selectedItems[i].item;
        }
        selectedItems[i].newStock = -Math.abs(
          parseFloat(selectedItems[i].invoicedQty || 0)
        );
        formData.append("items[]", JSON.stringify(selectedItems[i]));
      }

      let invoiceStatus = "PARTIAL_PAID";
      if (isSubContractor) {
        if (toDecimal(state.invoiceTotal.approvedSubTotal || 0).equals(toDecimal(state.invoiceTotal.subTotal || 0))) {
          invoiceStatus = "PAID";
        }
      } else {
        if (fields.invoiceClaim.value === fields.approvedPayment.value) {
          invoiceStatus = "PAID";
        }
      }
      formData.append("invoiceStatus", invoiceStatus);
      formData.append("isSubContractor", isSubContractor);

      // Mirror the display panel calculation exactly
      const retention = parseFloat(fields.lessRetention.value || 0);
      const totalForPaymentExcGst = toDecimal(state.invoiceTotal.approvedSubTotal || 0)
        .minus(toDecimal(retention))
        .toNumber();
      const gstOnPayment = toDecimal(totalForPaymentExcGst)
        .times(toDecimal(state.invoiceTotal.gst || 0))
        .dividedBy(100)
        .toNumber();
      const amountPaid = toDecimal(totalForPaymentExcGst).plus(toDecimal(gstOnPayment)).toNumber();

      formData.append("amountPaid", amountPaid);

      // approvedPayment = approvedSubTotal (exc GST, retention NOT deducted)
      formData.set("approvedPayment", state.invoiceTotal.approvedSubTotal);

      // taxAmount = GST on the payment amount (mirrors display)
      formData.set("taxAmount", gstOnPayment);

      // For subcontractors, invoiceClaim is always the sum of all claimAmount values from items
      if (isSubContractor) {
        const totalClaimAmount = state.items.reduce(
          (sum, item) => sum + parseFloat(item.claimAmount || 0),
          0
        );
        formData.set("invoiceClaim", toDecimal(totalClaimAmount));
      }

      let result = await dispatch(setVendorPayment(formData, poId)).catch(
        (e) => {
          throw e;
        }
      );
      if (result) {
        if (handleDownloadDialog && !state.isSubContractor) {
          const downloadId = state.poId;
          const templateType = "purchase_order";
          handleDownloadDialog(downloadId, templateType);
        }
        if (getWOList) getWOList();
        if (handleClose) handleClose();
        if (props.getPOList) props.getPOList();
      }

      if (payInvoiceType === "workOrder") getWOList(); // Assuming this function exists to get the work order list
    }
  };

  const getPurchaseOrder = async (id = "") => {
    const query = `?poId=${id || state.poId}`;
    let po = await dispatch(getProjectPurchaseOrder(query)).catch((e) => {
      throw e;
    });

    //change invoiceDate value using this function
    inputChangeHandler(
      { target: { value: po.deliveryDate, name: "invoiceDate", type: "date" } },
      "invoiceDate"
    );

    const poItems = idx(po, (_) => _.items) || [];
    const items = [];

    Array.isArray(poItems) &&
      poItems.forEach((item) => {
        if (isSubContractor) {
          item.retention = 0;
          item.claimAmount = 0;
          item.approvedAmount = 0;
          items.push(item);
        } else {
          const thisInv = parseFloat(item.thisInv || 0);
          if (thisInv > 0) {
            item.invoicedQty = parseFloat(item.thisInv || 0);
            item.amountPaid =
              parseFloat(item.thisInv || 0) * parseFloat(item.cost || 0);
            if (
              Number(item.receivedQty) - Number(item.previousInv) === 0 &&
              !isSubContractor
            ) {
              item.invoiceAll = true;
              item.selected = true;
            }
            items.push(item);
          }
        }
      });

    setState((prevState) => ({
      ...prevState,
      items,
      isDEpo: po.is_de_po,
      fId: po.f_id,
      vendorName: idx(po, (_) => _.vendor.business_name) || idx(po, (_) => _.vendor.name),
      projectName: idx(po, (_) => _.project.name) || idx(po, (_) => _.project.projectName),
      ...(po.vendor.paymentTerms
        ? { paymentTerms: po.vendor.paymentTerms }
        : { paymentTerms: 0 }),
    }));

    setFields((prev) => ({
      ...prev,
      progressClaimNumber: {
        ...prev.progressClaimNumber,
        value: po.nextProgressClaimNumber || 1,
      },
    }));

    setLockUnitCosts(Array(items.length).fill(true));
  };

  const getProject = async () => {
    let projects = await dispatch(getProjectList(null, "PROJECT")).catch((e) => {
      throw e;
    });

    let projectsList = [];
    if (Array.isArray(projects)) {
      projects.forEach(({ name, id }) => {
        projectsList.push({ key: name, value: id.toString() });
      });
    }
    projectsList = _.orderBy(
      projectsList,
      [({ key }) => key.toLowerCase()],
      "asc"
    );

    setState((prevState) => ({
      ...prevState,
      projectsList,
    }));
  };

  const changeProject = async (value, initialVendorId = null) => {
    if (!value) {
      setState((prevState) => ({
        ...prevState,
        projectId: "",
        vendorsList: [],
        vendorId: null,
        poId: null,
        poList: [],
        items: [],
      }));
      return;
    }

    try {
      // Clear current lists immediately to prevent showing stale data from previous project
      setState((prevState) => ({
        ...prevState,
        projectId: value.toString(),
        vendorsList: [],
        vendorId: initialVendorId ? initialVendorId.toString() : null,
        poId: initialVendorId ? prevState.poId : null,
        poList: [],
        items: [],
      }));

      const apiVendorType = state.selectedVendorType === VENDOR_TYPE_LABEL.CONTRACTOR
        ? 'sub-contractor'
        : 'Supplier';

      let vendorsList = await dispatch(
        getPoVendors(value, apiVendorType)
      ).catch((e) => {
        throw e;
      });

      const vendors = [];
      const sortedVendors = sortVendorList(vendorsList);

      Array.isArray(sortedVendors) &&
        sortedVendors.forEach((vendor) => {
          const vId = idx(vendor, (_) => _.vendor.id);
          if (vId && !vendors.find(({ value }) => value.toString() === vId.toString())) {
            vendors.push({
              key: idx(vendor, (_) => _.vendor.business_name) || "",
              value: vId.toString(),
            });
          }
        });

      setState((prevState) => ({
        ...prevState,
        vendorsList: vendors,
        // Only keep the vendorId if it was passed as initialVendorId
        vendorId: initialVendorId ? initialVendorId.toString() : null,
      }));
    } catch (e) {
      console.error(e);
    }
  };

  const changeVendor = async (
    value,
    projectIdOverride = null,
    initialPoId = null
  ) => {
    try {
      const projectId = projectIdOverride || state.projectId;

      const apiVendorType =
        state.selectedVendorType === VENDOR_TYPE_LABEL.CONTRACTOR
          ? "sub-contractor"
          : "Supplier";

      let { list: poList } = await dispatch(
        getPOList({
          vendorId: value,
          projectId,
          vendorType: apiVendorType,
          vendorOrdersPage: true // Ensure consistency with initialization
        })
      ).catch((e) => {
        throw e;
      });

      const POs = [];

      const getInvoiceStatus = (vType, po) => {
        const vTypeLower = (vType || "").toLowerCase();
        const isSupplierType = vTypeLower === "supplier" || vTypeLower === "2";
        const isContractorType = vTypeLower === "sub-contractor" || vTypeLower === "contractor" || vTypeLower === "1";

        if (isSupplierType)
          return (
            po.invoicestatus !== "Fully Invoiced" &&
            state.selectedVendorType === VENDOR_TYPE_LABEL.SUPPLIER
          );
        if (isContractorType)
          return (
            po.status !== "Completed" &&
            state.selectedVendorType === VENDOR_TYPE_LABEL.CONTRACTOR
          );
        return false;
      };

      Array.isArray(poList) &&
        poList.forEach((po) => {
          const vType = idx(po, (_) => _.vendor?.type);
          if (getInvoiceStatus(vType, po)) {
            POs.push({
              key: `${po.f_id || po.id}`,
              value: po.u_id.toString(),
              type: vType,
            });
          }
        });

      setState((prevState) => ({
        ...prevState,
        vendorId: value.toString(),
        poList: POs,
        poId: initialPoId ? initialPoId.toString() : (value == prevState.vendorId ? prevState.poId : null),
      }));
    } catch (e) {
      console.error(e);
    }
  };

  const changePO = (value) => {
    const { poList } = state;
    const po = poList.find((item) => item.value == value) || {};
    const isSubContractor =
      (po?.vendorType || po?.type) === VENDOR_TYPE.SUB_CONTRACTOR
        ? true
        : false;
    const _fields = _.cloneDeep(fields);
    _fields.approvedPayment.disable = !isSubContractor;
    _fields.dueDate.value = "";
    _fields.invoiceDate.value = "";
    setFields((prev) => ({
      ...prev,
      ..._fields,
    }));

    setState((prev) => ({
      ...prev,
      poId: po.value,
      isSubContractor,
    }));

    getPurchaseOrder(po.value);
  };

  const changeVendorType = (value) => {
    setState((prevState) => ({
      ...prevState,
      selectedVendorType: value,
      isSubContractor: value === VENDOR_TYPE_LABEL.CONTRACTOR ? true : false,
      projectId: null,
      vendorId: null,
      poId: null,
      projectsList: [], // Clear projects list when vendor type changes
      vendorsList: [],
      poList: [],
    }));
    getProject(); // Reload projects based on the new vendor type
  };

  const updateAmountPaid = (checked, item) => {
    // item.invoicedQty = checked ? Number(item.qty) - Number(item.previousInv) : 0
    const thisInv = parseFloat(item.thisInv || 0);
    item.invoicedQty = checked ? thisInv : 0;
    const baseAmount = checked ? thisInv * parseFloat(item.cost || 0) : 0;
    // amountPaid = baseAmount - retention + GST (always includes tax)
    if (baseAmount > 0) {
      const retention = parseFloat(item.retention || 0);
      const afterRetention = toDecimal(baseAmount).minus(toDecimal(retention));
      const gst = afterRetention.times(toDecimal(state.invoiceTotal.gst || 0)).dividedBy(100);
      item.amountPaid = afterRetention.plus(gst).toNumber();
    } else {
      item.amountPaid = baseAmount;
    }
  };

  const handleInvoiceAllChange = (checked) => {
    setIsInvoiceAll(checked);
    Array.isArray(state.items) &&
      state.items.length &&
      state.items.map((item, index) => {
        item.invoiceAll = checked;
        item.selected = checked;
        updateAmountPaid(checked, item);
        itemChangeHandler(checked, index, "invoiceAll");
      });
  };

  const handleSelectAllChange = (checked) => {
    setIsSelectAll(checked);
    Array.isArray(state.items) &&
      state.items.length &&
      state.items.map((item, index) => {
        item.selected = checked;
        itemChangeHandler(checked, index, "checkbox");
      });
  };

  const itemChangeHandler = (value, index, inputType) => {
    const items = _.cloneDeep(state.items);
    const invoiceTotal = _.cloneDeep(state.invoiceTotal);
    const { isSubContractor } = state;
    const item = _.cloneDeep(items[index]);

    if (inputType === "invoiceAll") {
      if (!isSubContractor) {
        item.selected = value;
      }
      item.invoiceAll = value;
      updateAmountPaid(value, item);
    }
    if (inputType === "checkbox") {
      item.selected = value;
    } else if (inputType === "approvedAmount") {
      const amount = toDecimal(toDecimal(value || 0).isNegative() ? 0 : toDecimal(value || 0).toDecimalPlaces(2));
      const remaining = toDecimal(item.total || 0).minus(toDecimal(item.previousInv || 0));
      const claimCeiling = toDecimal(item.claimAmount || 0);
      const ceiling = claimCeiling.greaterThan(0) ? (claimCeiling.lessThan(remaining) ? claimCeiling : remaining) : remaining;

      if (amount.greaterThan(remaining)) {
        dispatch(warningSnackBar(`Approved amount exceeds remaining balance — max allowed is ${toUSD(remaining.toNumber())}`));
      } else if (claimCeiling.greaterThan(0) && amount.greaterThan(claimCeiling)) {
        dispatch(warningSnackBar(`Approved amount cannot exceed the invoice claim of ${toUSD(claimCeiling.toNumber())}`));
      }

      item.approvedAmount = amount.toNumber();
      // amountPaid = approvedAmount - retention + GST
      const baseAmount = amount.minus(toDecimal(item.retention || 0));
      const gst = baseAmount.times(toDecimal(state.invoiceTotal.gst || 0)).dividedBy(100);
      item.amountPaid = baseAmount.plus(gst).toNumber();
    } else if (inputType === "invQty") {
      const invQty = toDecimal(value || 0).isNegative()
        ? toDecimal(0)
        : toDecimal(value || 0);
      // amountPaid = approvedAmount - retention + GST
      const retention = toDecimal(item.retention || 0);
      const afterRetention = toDecimal(item.approvedAmount || 0).minus(retention);
      const gst = afterRetention.times(toDecimal(state.invoiceTotal.gst || 0)).dividedBy(100);
      item.amountPaid = afterRetention.plus(gst).toNumber();

      item.invoicedQty = invQty.toNumber();
      if (!isSubContractor) {
        if (invQty.toNumber() === 0) {
          item.invoiceAll = false;
          item.selected = false;
        } else {
          item.selected = true;
        }
      }
      if (value > Number(item.thisInv)) return;
    } else if (inputType === "retention") {
      const approvedAmount = toDecimal(item.approvedAmount || 0);
      const retention = toDecimal(value || 0).isNegative()
        ? toDecimal(0)
        : toDecimal(value || 0);

      if (retention.greaterThan(approvedAmount)) {
        dispatch(warningSnackBar('Retention cannot exceed the approved amount'));
        return;
      }

      item.retention = retention.toNumber();
      // amountPaid = approvedAmount - retention + GST
      const baseAmount = toDecimal(item.approvedAmount || 0).minus(retention);
      const gst = baseAmount.times(toDecimal(state.invoiceTotal.gst || 0)).dividedBy(100);
      item.amountPaid = baseAmount.plus(gst).toNumber();
    } else if (inputType === "claimAmount") {
      const amount = toDecimal(toDecimal(value || 0).isNegative() ? 0 : toDecimal(value || 0).toDecimalPlaces(2));
      const remaining = toDecimal(item.total || 0).minus(toDecimal(item.previousInv || 0));

      if (amount.greaterThan(remaining)) {
        dispatch(warningSnackBar(`Claim amount exceeds limit — max allowed is ${toUSD(remaining.toNumber())}`));
      }

      item.claimAmount = amount.toNumber();
    } else if (inputType === "unitCost") {
      const itemCost = toDecimal(value || 0).isNegative()
        ? toDecimal(0)
        : toDecimal(value || 0);
      item.cost = itemCost.toNumber();
      item.amountPaid = toDecimal(item.invoicedQty || 0)
        .times(itemCost)
        .toNumber();
    }

    items[index] = _.cloneDeep(item);
    if (inputType === "checkbox") {
      const allChecked = items.every((item) => item.selected);
      setIsSelectAll(allChecked);
    }
    if (
      inputType === "invoiceAll" ||
      (!isSubContractor && inputType === "invQty")
    ) {
      const inovoiceAllChecked = items.every((item) => item.invoiceAll);
      setIsInvoiceAll(inovoiceAllChecked);
    }

    let totalAmountPaid = 0;
    let total = 0;
    let retentionAmount = 0;

    items.forEach(
      ({ selected, amountPaid, approvedAmount, claimAmount, retention }) => {
        if (selected || isSubContractor) {
          if (isSubContractor) {
            total = toDecimal(total)
              .plus(toDecimal(approvedAmount || 0))
              .toNumber();
            retentionAmount = toDecimal(retentionAmount)
              .plus(toDecimal(retention || 0))
              .toNumber();
            totalAmountPaid = toDecimal(totalAmountPaid)
              .plus(toDecimal(approvedAmount || 0))
              .toNumber();
          } else {
            total = toDecimal(total)
              .plus(toDecimal(amountPaid || 0))
              .toNumber();
            totalAmountPaid = toDecimal(totalAmountPaid)
              .plus(toDecimal(amountPaid || 0))
              .toNumber();
          }
        }
      }
    );

    const taxAmount = toDecimal(total)
      .times(toDecimal(invoiceTotal.gst || 0))
      .dividedBy(100)
      .toNumber();
    invoiceTotal.subTotal = total;
    invoiceTotal.taxAmount = taxAmount;
    invoiceTotal.total = toDecimal(total).plus(toDecimal(taxAmount)).toNumber();

    let approvedTaxAmount = 0;
    let finalApprovedTotal = 0;
    let totalForPaymentExcGst = toDecimal(0);

    if (isSubContractor) {
      // Subcontractor calculation flow:
      // Calculate previous invoices sum
      let sumPreviousInv = 0;
      items.forEach((item) => {
        sumPreviousInv = toDecimal(sumPreviousInv)
          .plus(toDecimal(item.previousInv || 0))
          .toNumber();
      });

      // Retention is separate - NOT deducted from claimed/approved amounts
      // Calculate GST on the base amount (without retention)
      approvedTaxAmount = toDecimal(totalAmountPaid)
        .times(toDecimal(invoiceTotal.gst || 0))
        .dividedBy(100)
        .toNumber();

      invoiceTotal.approvedSubTotal = totalAmountPaid; // Total Approved (This Claim) - NO retention deduction
      invoiceTotal.approvedTaxAmount = approvedTaxAmount; // GST calculated on base amount

      // approvedTotal includes GST for display/tax purposes, but retention is NOT deducted
      invoiceTotal.approvedTotal = toDecimal(totalAmountPaid).plus(toDecimal(approvedTaxAmount)).toNumber();

      // approvedPayment is the base amount WITHOUT retention and WITHOUT GST
      finalApprovedTotal = totalAmountPaid;
    } else {
      // Supplier calculation flow:
      // Retention is separate - NOT deducted from claimed/approved amounts
      approvedTaxAmount = toDecimal(totalAmountPaid)
        .times(toDecimal(invoiceTotal.gst || 0))
        .dividedBy(100)
        .toNumber();
      invoiceTotal.approvedSubTotal = totalAmountPaid;
      invoiceTotal.approvedTaxAmount = approvedTaxAmount;
      invoiceTotal.approvedTotal = toDecimal(totalAmountPaid).plus(toDecimal(approvedTaxAmount)).toNumber();

      // approvedPayment is the base amount WITHOUT retention and WITHOUT GST
      finalApprovedTotal = totalAmountPaid;
    }

    setFields((prev) => ({
      ...prev,
      // invoiceClaim is NOT auto-calculated - preserves user manual input entirely
      approvedPayment: {
        ...prev.approvedPayment,
        value: finalApprovedTotal,
      },
    }));

    setState((prevState) => ({
      ...prevState,
      items,
      invoiceTotal,
    }));
  };

  const handleDownloadPaymentSchedule = () => {
    if (!handleDownloadDialog) return;

    const overrideData = {
      isNew: !invoiceId && !props.invoiceId,
      poId: state.poId,
      invoiceNo: fields.invoiceNumber.value,
      invoiceClaim: fields.invoiceClaim.value,
      approvedAmount: state.invoiceTotal.approvedTotal,
      retentionAmount: fields.lessRetention.value,
      progress_claim_number: fields.progressClaimNumber?.value,
      invoice_approval_notes: fields.notes.value,
      items: state.items,
    };

    handleDownloadDialog(
      invoiceId || props.invoiceId || state.poId,
      state.isSubContractor ? 'subcontractor_payment_schedule' : 'purchase_order',
      overrideData
    );
  };

  const isLimitExceeded = state.items.some((item) => {
    const remaining = toDecimal(item.total || 0).minus(toDecimal(item.previousInv || 0));
    if (state.isSubContractor) {
      return toDecimal(item.claimAmount || 0).greaterThan(remaining) ||
             toDecimal(item.approvedAmount || 0).greaterThan(remaining);
    }
    return item.selected && toDecimal(item.amountPaid || 0).greaterThan(remaining);
  });

  return (
    <>
      <Modal
        open={!showAddItem && true}
        onClose={() => props.handleClose(false)}
        onClick={() => {
          if (isLimitExceeded) {
            dispatch(warningSnackBar('One or more items exceed the remaining uninvoiced amount. Please review the amounts before submitting.'));
            return;
          }
          submitForm(true);
        }}
        modalHeading={"Receive Invoice"}
        modalSaveTxt={"Receive Invoice"}
        modalCloseTxt="Cancel"
        modalCloseBtn={() => props.handleClose(false)}
        showActionBtn={true}
        fullWidth={true}
        maxWidth={"xl"}
        cxlbtnclassName="cancelBtn"
        savebtnclassName="createBtn"
        modalSaveTxtDisabledClass={isLimitExceeded ? 'disabled opacity-50' : ''}
        primary
        data-cy="receive-invoice-modal"
      >
        <div className="purchase-order-block mb-3" data-cy="container">
          <div className="row">
            <div className="col-lg-4 col-md-4 mt-3">
              <SelectInput
                label="Select Vendor Type"
                placeholder="Vendor Type"
                items={[
                  { key: VENDOR_TYPE_LABEL.SUPPLIERS, value: VENDOR_TYPE_LABEL.SUPPLIER },
                  {
                    key: VENDOR_TYPE_LABEL.CONTRACTORS,
                    value: VENDOR_TYPE_LABEL.CONTRACTOR,
                  },
                ]}
                value={state.selectedVendorType}
                onChange={(e) => changeVendorType(e.target.value)}
                data-cy="vendor-type-dropdown"
              />
            </div>
            <div className="col-lg-4 col-md-4 mt-3">
              <SelectInput
                label="Select Project"
                placeholder="Project"
                items={state.projectsList}
                value={state.projectId}
                onChange={(e) => changeProject(e.target.value)}
                data-cy="project-dropdown"
              />
            </div>
            <div className="col-lg-4 col-md-4 mt-3">
              <SelectInput
                label="Select Vendor"
                placeholder="Vendor"
                items={state.vendorsList}
                value={state.vendorId}
                onChange={(e) => changeVendor(e.target.value)}
                data-cy="vendor-dropdown"
              />
            </div>
            <div className="col-lg-4 col-md-4 mt-3">
              <SelectInput
                label="Select Purchase Order"
                placeholder="Purchase Order"
                items={state.poList}
                value={state.poId}
                onChange={(e) => changePO(e.target.value)}
                data-cy="po-dropdown"
              />
            </div>
            <div className="col-lg-4 col-md-4 mt-3">
              <CustomInput
                {...fields.invoiceNumber}
                onChange={(e) => inputChangeHandler(e, "invoiceNumber")}
                data-cy="invoice-number-input"
              />
            </div>
            <div className="col-lg-4 col-md-6 mt-3">
              <DatePickerInput
                placeholder="Enter Invoice Date"
                {...fields.invoiceDate}
                onChange={(e, context) => {
                  inputChangeHandler(
                    {
                      target: { value: e, name: "invoiceDate", type: "date" },
                    },
                    "invoiceDate"
                  );
                }}
                data-cy="invoice-date-input"
              />
            </div>
            <div className="col-lg-4 col-md-6 mt-3">
              <DatePickerInput
                placeholder="Enter Due Date"
                {...fields.dueDate}
                onChange={(e, context) => {
                  inputChangeHandler(
                    {
                      target: {
                        value: e,
                        name: fields.dueDate.name,
                        type: "date",
                      },
                    },
                    fields.dueDate.name
                  );
                }}
                data-cy="due-date-input"
              />
            </div>
            <div className="col-lg-4 col-md-4 mt-3 fileupload-section">
              <div className="file-section-part position-relative h-auto px-0">
                <div className="file-part" data-cy="file-section">
                  <FileUploader
                    fileHandler={(files) =>
                      inputChangeHandler({
                        target: { files, type: "file", name: "attachment" },
                      })
                    }
                  />
                  <label htmlFor="#file-section"></label>
                </div>
                <input type="file" id="file-section"></input>
              </div>
            </div>
            <div className="col-lg-4 col-md-4 mt-3">
              <div
                className="form-group text-left position-relative h-auto"
                data-cy="attachment"
              >
                <div className="input-block">
                  <label className="input-label">
                    {fields.attachment.label}
                  </label>
                  <p className="m-0 doc-info">
                    <span>
                      {fields.attachment?.value?.name || "No file selected"}
                    </span>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        {state.poId && (
          <>
            <div className="col-12">
              <div className="material-list-block mt-4">
                <div className="table-responsive pay-invoice-table-responsive">
                  <Table
                    bordered
                    className={`table-create table-material table-material-ch tbl-fixed pay-invoice-table ${state.isDEpo ? "has-task-column" : ""
                      }`}
                  >
                    <thead>
                      <tr>
                        {state.isSubContractor ? (
                          <>
                            <th className="w-auto" data-cy="task-header">
                              Task
                            </th>
                            <th className="w-auto" data-cy="description-header">
                              Description
                            </th>
                            <th
                              className="text-right"
                              data-cy="total-cost-header"
                            >
                              Total Cost
                            </th>
                            <th data-cy="previous-inv-header" className="text-right">Claimed</th>
                            <th
                              className="text-right"
                              data-cy="invoice-claim-header"
                            >
                              Invoice Claim
                            </th>
                            <th data-cy="approved-amount-header" className="text-right">
                              Approved Amount
                            </th>
                          </>
                        ) : (
                          <>
                            {!state.isDEpo && (
                              <th className="w-auto" data-cy="task-header">
                                Task
                              </th>
                            )}
                            {/* <th>Catalog</th> */}
                            <th data-cy="item-description-header">
                              Item Description
                            </th>
                            <th data-cy="category-header">Category</th>
                            <th data-cy="part-no-header">Part No</th>
                            <th
                              className="text-right"
                              data-cy="unit-cost-header"
                            >
                              Unit Cost
                            </th>
                            <th data-cy="ordered-quantity-header">Ordered</th>
                            <th data-cy="already-received-header">Received</th>
                            {/* <th>Previous Inv</th> */}
                            <th data-cy="quantity-left-header">
                              Remaining <br />
                              to Invoice
                            </th>
                            <th data-cy="quantity-to-receive-header">
                              Qty to Invoice
                            </th>
                            {/* <th>UoM</th> */}
                            <th className="text-right" data-cy="total-header">
                              Total
                            </th>
                            <th className="w-auto" data-cy="invoice-all-header">
                              <div class="table-checkbox">
                                <Form.Check
                                  id={"invoiceAll"}
                                  type={"checkbox"}
                                  value={isInvoiceAll}
                                  checked={isInvoiceAll}
                                  data-cy="invoice-all-checkbox"
                                  onChange={(e) => {
                                    handleInvoiceAllChange(e.target.checked);
                                  }}
                                />
                                <Form.Check.Label for={"invoiceAll"}>
                                  Invoice All
                                </Form.Check.Label>
                              </div>
                            </th>
                          </>
                        )}
                      </tr>
                    </thead>
                    <tbody>
                      {!state.isSubContractor ? (
                        <>
                          {(Array.isArray(state.items) &&
                            state.items.length &&
                            state.items.map((item, index) => (
                              <tr key={index}>
                                {!state.isDEpo && (
                                  <td data-cy="task">{item.taskName}</td>
                                )}
                                {/* <td data-cy="category">{item.category}</td> */}
                                <td data-cy="items-description">{item.item}</td>
                                <td data-cy="manufacturer">
                                  {item.manufacturer}
                                </td>
                                <td data-cy="part-no">{item.partNo}</td>
                                <td
                                  className="align-items-center"
                                  data-cy="unit-cost"
                                >
                                  {!lockUnitCosts[index] && (
                                    <span
                                      className="me-1 task-edit-icon"
                                      data-cy="edit-icon"
                                    >
                                      <EditIcon
                                        onClick={() => handleEditClick(index)}
                                      />
                                    </span>
                                  )}
                                  <LockInput
                                    className={"input-block-sm text-right"}
                                    key={index}
                                    lock={
                                      <span className="lock-icon">
                                        {lockUnitCosts[index] && (
                                          <LockIcon
                                            onClick={(e) =>
                                              handleUnitCostLock(index)
                                            }
                                          />
                                        )}
                                        {!lockUnitCosts[index] && (
                                          <LockOpenIcon
                                            onClick={(e) =>
                                              handleUnitCostLock(index)
                                            }
                                          />
                                        )}
                                      </span>
                                    }
                                    name="unitCost"
                                    type="number"
                                    value={roundValue(item.cost || 0, 2)}
                                    required={true}
                                    onChange={(e) =>
                                      itemChangeHandler(
                                        e.target.value,
                                        index,
                                        "unitCost"
                                      )
                                    }
                                    disabled={lockUnitCosts[index]}
                                    data-cy="unit-cost-input"
                                  />
                                </td>
                                <td data-cy="ordered-quantity">{item.qty}</td>
                                <td data-cy="already-received">
                                  {item.receivedQty}
                                </td>
                                {/* <td data-cy="previous-inv">{item.previousInv}</td> */}
                                <td data-cy="quantity-left">
                                  {isInvoiceAll
                                    ? 0
                                    : Number(item.qty) -
                                    Number(item.previousInv) -
                                    Number(item.invoicedQty)}
                                </td>
                                <td>
                                  <CustomInput
                                    className="input-block-sm"
                                    type="number"
                                    value={item.invoicedQty}
                                    onChange={(e) =>
                                      itemChangeHandler(
                                        e.target.value,
                                        index,
                                        "invQty"
                                      )
                                    }
                                    data-cy="this-inv-input"
                                  />
                                </td>
                                {/* <td data-cy="uom">{item.unit}</td> */}
                                <td className="text-right" data-cy="total">
                                  {toUSD(item.amountPaid)}
                                </td>
                                <td>
                                  <div className="table-checkbox">
                                    <Form.Check
                                      type={"checkbox"}
                                      checked={item.invoiceAll}
                                      value={item.invoiceAll}
                                      onChange={(e) =>
                                        itemChangeHandler(
                                          e.target.checked,
                                          index,
                                          "invoiceAll"
                                        )
                                      }
                                      data-cy="invoice-item-checkbox"
                                    />
                                  </div>
                                </td>
                              </tr>
                            ))) || (
                              <tr>
                                <td
                                  className="text-center"
                                  colSpan={!state.isDEpo ? 13 : 12}
                                >
                                  No Items to Show
                                </td>
                              </tr>
                            )}
                        </>
                      ) : (
                        <>
                          {(Array.isArray(state.items) &&
                            state.items.length &&
                            state.items.map((item, index) => (
                              <tr key={index}>
                                <td data-cy="task">{item.taskName}</td>
                                <td data-cy="description">{item.name || '-'}</td>
                                <td className="text-right" data-cy="total-cost">
                                  {toUSD(item.total)}
                                </td>
                                <td className="text-right" data-cy="previous-inv">
                                  {toUSD(item.previousInv || 0)}
                                </td>
                                {(() => {
                                  const isFullyInvoiced = toDecimal(item.previousInv || 0).greaterThanOrEqualTo(toDecimal(item.total || 0));
                                  return (
                                    <>
                                      <td>
                                        <CustomInput
                                          className="input-block-sm"
                                          type="number"
                                          customInputClass="text-right"
                                          value={item.claimAmount}
                                          disabled={isFullyInvoiced}
                                          onChange={(e) =>
                                            itemChangeHandler(
                                              e.target.value,
                                              index,
                                              "claimAmount"
                                            )
                                          }
                                          data-cy="claim-amount-input"
                                        />
                                      </td>
                                      <td>
                                        <CustomInput
                                          className="input-block-sm"
                                          type="number"
                                          customInputClass="text-right"
                                          value={item.approvedAmount}
                                          disabled={isFullyInvoiced}
                                          onChange={(e) =>
                                            itemChangeHandler(
                                              e.target.value,
                                              index,
                                              "approvedAmount"
                                            )
                                          }
                                          data-cy="approved-amount-input"
                                        />
                                      </td>
                                    </>
                                  );
                                })()}
                              </tr>
                            ))) || (
                              <tr>
                                <td colSpan={6} className="text-center">
                                  No Items to Show
                                </td>
                              </tr>
                            )}
                        </>
                      )}
                    </tbody>
                    {state.isSubContractor && state.items.length > 0 && (
                      <tfoot>
                        <tr>
                          <td colSpan={2} className="text-right fw-bold" style={{ paddingRight: '20px' }}>Totals:</td>
                          <td className="text-right fw-bold">
                            {toUSD(state.items.reduce((sum, item) => sum + parseFloat(item.total || 0), 0))}
                          </td>
                          <td className="text-right fw-bold" style={{ paddingRight: '8px' }}>
                            {toUSD(state.items.reduce((sum, item) => sum + parseFloat(item.previousInv || 0), 0))}
                          </td>
                          <td className="text-right fw-bold" style={{ paddingRight: '18px' }}>
                            {toUSD(state.items.reduce((sum, item) => sum + parseFloat(item.claimAmount || 0), 0))}
                          </td>
                          <td className="text-right fw-bold" style={{ paddingRight: '18px' }}>
                            {toUSD(state.invoiceTotal.approvedSubTotal)}
                          </td>
                        </tr>
                      </tfoot>
                    )}
                  </Table>
                </div>
              </div>
            </div>
            <div className="row mt-4">
              <div className="col-lg-6 col-md-6 border-right">
                <div className="row">
                  {state.isSubContractor && (
                    <div className="col-12">
                      <CustomInput
                        {...fields.progressClaimNumber}
                        onChange={(e) => inputChangeHandler(e, "progressClaimNumber")}
                        data-cy="progress-claim-number-input"
                      />
                    </div>
                  )}
                  <div className="col-12 mt-3">
                    <TextAreaInput
                      {...fields.notes}
                      label={"Notes"}
                      onChange={(e) => inputChangeHandler(e, "notes")}
                      data-cy="notes-input"
                      rows={5}
                    />
                  </div>

                </div>
              </div>
              <div className="col-lg-6 col-md-6">
                <div className="invoice-summary-block px-3">
                  {(() => {
                    const sumPreviousInv = state.isSubContractor
                      ? state.items.reduce((sum, item) => sum + parseFloat(item.previousInv || 0), 0)
                      : 0;
                    const totalForPaymentExcGst = toDecimal(state.invoiceTotal.approvedSubTotal || 0)
                      .minus(toDecimal(fields.lessRetention.value || 0))
                      .toNumber();
                    const gstOnPayment = toDecimal(totalForPaymentExcGst)
                      .times(toDecimal(state.invoiceTotal.gst || 0))
                      .dividedBy(100)
                      .toNumber();
                    return (
                      <>
                        {state.isSubContractor && (
                          <div className="d-flex justify-content-between mb-2">
                            <label className="fw-bold">Less Previously Approved</label>
                            <p className="m-0 pe-1">
                              <b>{toUSD(-sumPreviousInv)}</b>
                            </p>
                          </div>
                        )}

                        <div className="d-flex justify-content-between mb-2">
                          <label className="fw-bold">
                            {state.isSubContractor ? "Total Approved (This Claim)" : "Sub Total"}
                          </label>
                          <p className="m-0 pe-1">
                            <b>
                              {toUSD(
                                state.invoiceTotal.approvedSubTotal || 0
                              )}
                            </b>
                          </p>
                        </div>

                        {state.isSubContractor && (
                          <div className="d-flex justify-content-between align-items-center mb-2">
                            <label className="fw-bold mb-0">Retention</label>
                            <div style={{ width: "150px", transform: "translateX(5px)" }}>
                              <CustomInput
                                {...fields.lessRetention}
                                label=""
                                className="input-block-sm"
                                onChange={(e) => inputChangeHandler(e, "lessRetention")}
                                customInputClass="text-right"
                              />
                            </div>
                          </div>
                        )}

                        <div className="d-flex justify-content-between mb-2 border-top pt-2">
                          <label className="fw-bold">
                            {state.isSubContractor ? "Total for Payment (Exc GST)" : "Total for Payment"}
                          </label>
                          <p className="m-0 pe-1">
                            <b>
                              {toUSD(totalForPaymentExcGst)}
                            </b>
                          </p>
                        </div>

                        <div className="d-flex justify-content-between mb-2">
                          <label className="fw-bold">
                            GST ({state.invoiceTotal.gst}%)
                          </label>
                          <p className="m-0 pe-1">
                            <b>{toUSD(gstOnPayment)}</b>
                          </p>
                        </div>

                        <div className="d-flex justify-content-between mb-2 border-top pt-2">
                          <label className="fw-bold h5">
                            {state.isSubContractor ? "Total for Payment (Inc GST)" : "Total"}
                          </label>
                          <p className="m-0 pe-1 h5 text-primary">
                            <b>
                              {toUSD(
                                toDecimal(totalForPaymentExcGst)
                                  .plus(toDecimal(gstOnPayment))
                                  .toNumber()
                              )}
                            </b>
                          </p>
                        </div>
                      </>
                    );
                  })()}

                  {state.isSubContractor && (
                    <div className="mt-4 text-right">
                      <button
                        className="btn btn-outline-primary w-100"
                        onClick={handleDownloadPaymentSchedule}
                        style={{ border: "2px solid", fontWeight: "bold" }}
                      >
                        Download Payment Schedule
                      </button>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </>
        )}
      </Modal>
      <AddItemDialog
        open={showAddItem}
        submitHandler={(res) => {
          editItemHandler(res);
        }}
        dialogClose={() => setShowAddItem(false)}
        categoryId={idx(material, (_) => _.categoryId) || ""}
        itemName={idx(material, (_) => _.itemName) || ""}
        params={{ itemId: idx(material, (_) => _.itemId) }}
        manufacturer={idx(material, (_) => _.manufacturer) || ""}
        partNo={idx(material, (_) => _.partNo) || ""}
        unitCost={idx(material, (_) => _.unitCost) || ""}
        unit={idx(material, (_) => _.unit) || ""}
        taskId={idx(material, (_) => _.taskId) || ""}
        modalTitle="Edit Item"
        writePermission={wCatalogPermission}
      />
    </>
  );
}
